/**
 * Created by Jerker Nord on 2018-05-21.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineLite, TweenLite} from "gsap";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiSoundConfig} from "../../IceIceYetiSoundConfig";
import {IStickySymbol} from "../../reelstoppresentation/stickysymbol/IStickySymbol";
import {IceIceYetiReelSymbol} from "../../symbol/IceIceYetiReelSymbol";
import {StickySymbol} from "../../symbol/StickySymbol";

export class IceIceYetiStickySymbolWPView extends BaseView {

    private _layer:ScalableLayer;
    private _newStickySymbols:IStickySymbol[];
    private _allStickySymbols:IStickySymbol[];
    private _newStickySymbolsAnimationTL:TimelineLite;
    private _stickySymbolAnimationAborted:boolean;
    private _freezeAnimations:TimelineLite[][];
    private _freezeAnimationsDelay:number[] = [0.8, 0.6, 0.4, 0.2];

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.STICKY_SYMBOL_OVERLAY.name);
        this._allStickySymbols = [];
        this._newStickySymbols = [];
        this._newStickySymbolsAnimationTL = new TimelineLite({paused : true});
        this._stickySymbolAnimationAborted = false;
    }

    protected initAnimations():void {
        this._layer.addChild(this);
    }

    public addNewStickySymbol(stickySymbol:StickySymbol, position:PIXI.Point):void {
        stickySymbol.position.x = Helper.getSymbolPositions(position.x, position.y)[0];
        stickySymbol.position.y = Helper.getSymbolPositions(position.x, position.y)[1];
        this._newStickySymbols.push({symbolPosition : position, symbol : stickySymbol});
    }

    public sortNewStickySymbols(isRestore:boolean = false):void {
        let newSymbolNames:string[] = [];
        this._freezeAnimations = [];
        for(let i:number = 0; i < this._newStickySymbols.length; i++) {
            let symbolName:string = this._newStickySymbols[i].symbol.stickySymbolName;
            if(newSymbolNames.indexOf(symbolName) < 0) {
                newSymbolNames.push(symbolName);
            }
        }

        for(let j:number = 0; j < newSymbolNames.length; j++) {
            let freezeSymbolAnimations:TimelineLite[] = [];
            let delay:number;
            for(let k:number = 0; k < this._newStickySymbols.length; k++) {
                let stickySymbol:IStickySymbol = this._newStickySymbols[k];
                if(stickySymbol.symbol.stickySymbolName == newSymbolNames[j]) {
                    this.addChild(stickySymbol.symbol);
                    if(stickySymbol.symbol.firstFreeze == true) {
                        freezeSymbolAnimations.push(stickySymbol.symbol.getFreezeAnimation(isRestore));
                    }
                }
            }
            this._freezeAnimations.push(freezeSymbolAnimations);
            this._newStickySymbolsAnimationTL.add(() => SlotGame.sound.playEffect(IceIceYetiSoundConfig.instance.STICKY_SYMBOL_FREEZE));
            this._newStickySymbolsAnimationTL.add(() => this.playFreezeAnimation());
            if(isRestore) {
                delay = 0
            } else {
                if(j > 3) {
                    delay = 0.2;
                } else {
                    delay = this._freezeAnimationsDelay[j];
                }
            }

            this._newStickySymbolsAnimationTL.add(() => this.checkAborted(), "+=" + delay);
        }
    }

    private playFreezeAnimation():void {
        let freezeAnimation:TimelineLite[] = this._freezeAnimations.pop()!;
        for(let i:number = 0; i < freezeAnimation.length; i++) {
            freezeAnimation[i].restart();
        }
    }

    private checkAborted():void {
        if(this._stickySymbolAnimationAborted == true) {
            this.killAndResetStickySymAnimation();
        }
    }

    public getNewStickySymbolsTL():TimelineLite {
        return this._newStickySymbolsAnimationTL;
    }

    public addNewStickysToAllStickys():void {
        while(this._newStickySymbols.length > 0) {
            this._allStickySymbols.push(this._newStickySymbols.pop()!);
        }
    }

    public forceAllNewStickySymbols():void {
        this._stickySymbolAnimationAborted = true;
        let tempSymbol:StickySymbol;
        for(let i:number = 0; i < this._allStickySymbols.length; i++) {
            tempSymbol = this._allStickySymbols[i].symbol;
            if(tempSymbol.firstFreeze == true) {
                tempSymbol.getFreezeAnimation().restart();
            }
        }
    }

    public hideAllStickySymbols():void {
        this.visible = false;
    }

    public killAndResetStickySymAnimation():void {
        this._newStickySymbolsAnimationTL.kill();
        this._newStickySymbolsAnimationTL = new TimelineLite({paused : true});
        this._stickySymbolAnimationAborted = false;
    }

    //Restores the original sym on reel for spin out
    public restoreReelSymbols():void {
        for(let i:number = 0; i < this._allStickySymbols.length; i++) {
            TweenLite.to(Reels.getSymbol(this._allStickySymbols[i].symbolPosition.x, this._allStickySymbols[i].symbolPosition.y)!, 0.2, {alpha : 1});
        }
    }

    public removeAllStickySymbols():void {
        for(let i:number = 0; i < this._allStickySymbols.length; i++) {
            let tempReelSymbol:IceIceYetiReelSymbol = <IceIceYetiReelSymbol>Reels.getSymbol(this._allStickySymbols[i].symbolPosition.x, this._allStickySymbols[i].symbolPosition.y)!;
            tempReelSymbol.replaceWith(this._allStickySymbols[i].symbol.stickySymbolName, this._allStickySymbols[i].symbolPosition.x, IceIceYetiGameConfig.instance.SYMBOL_STATES.frozen);
            this.removeChild(this._allStickySymbols[i].symbol);
        }
        this._allStickySymbols = [];
    }

    get allStickySymbols():IStickySymbol[] {
        return this._allStickySymbols;
    }
}